import React from 'react';
import './../scss/JobTile.scss';
const { __ } = window.wp.i18n;

class JobTile extends React.Component {
  render () {
    const theDate = this.props.data.indexed_at;
    const theDatelenth = theDate.length;
    const monthNames = [__('Jan', 'macs-react-jobs'), __('Feb', 'macs-react-jobs'), __('Mar', 'macs-react-jobs'), __('Apr', 'macs-react-jobs'), __('May', 'macs-react-jobs'), __('Jun', 'macs-react-jobs'), __('Jul', 'macs-react-jobs'), __('Aug', 'macs-react-jobs'), __('Sep', 'macs-react-jobs'), __('October', 'macs-react-jobs'), __('Nov', 'macs-react-jobs'), __('Dec', 'macs-react-jobs')];
    let d = new Date(parseInt(theDate * 1000));
    const pathName = `${window.es_var.pathName}`;
    let base_slug = '';

    if (pathName !== '') {
      base_slug = '/' + pathName;
    }

    if (theDatelenth > 10) {
      d = new Date(theDate);
    }

    function formatDate () {
      const month = '' + monthNames[d.getMonth()];
      let day = '' + d.getDate();
      const year = d.getFullYear();

      if (day.length < 2) day = '0' + day;
      return month + ' ' + day + ', ' + year;
    }

    /**
       * Convert title to the slug.
       *
       * @param {string} title Post title.
       *
       * @return {string}
       */
    function convertToSlug (title) {
      let jobTitle = title.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
      jobTitle = jobTitle || '-';
      return jobTitle;
    }

    function getCountryNameByCode (CountryCode) {
      const pre_defined_country_list = [
        { key: 'fr-ma', value: 'Morocco' },
        { key: 'nl-nl', value: 'Netherlands' },
        { key: 'NL', value: 'Netherlands' },
        { key: 'es-mx', value: 'Mexico' },
        { key: 'it-it', value: 'Italy' },
        { key: 'it', value: 'Italy' },
        { key: 'ITA', value: 'Italy' },
        { key: 'cn-zh', value: 'China' },
        { key: 'zh-cn', value: 'China' },
        { key: 'CHN', value: 'China' },
        { key: 'zh-hans', value: 'China' },
        { key: 'es-es', value: 'Spain' },
        { key: 'es', value: 'Spain' },
        { key: 'ESP', value: 'Spain' },
        { key: 'ES', value: 'Spain' },
        { key: 'DE', value: 'Germany' },
        { key: 'de-de', value: 'Germany' },
        { key: 'pl-pl', value: 'Poland' },
        { key: 'en-pt', value: 'Portugal' },
        { key: 'pt-en', value: 'Portugal' },
        { key: 'PRT', value: 'Portugal' },
        { key: 'PT', value: 'Portugal' },
        { key: 'en-tw', value: 'Taiwan' },
        { key: 'tw-en', value: 'Taiwan' },
        { key: 'ar-sa', value: 'Saudi Arabia' },
        { key: 'sa-ar', value: 'Saudi Arabia' },
        { key: 'en-vn', value: 'Vietnam' },
        { key: 'vn-en', value: 'Vietnam' },
        { key: 'co-es', value: 'Colombia' },
        { key: 'es-co', value: 'Colombia' },
        { key: 'CO', value: 'Colombia' },
        { key: 'fr-fr', value: 'France' },
        { key: 'FRA', value: 'France' },
        { key: 'en-gb', value: 'United Kingdom' },
        { key: 'au-en', value: 'Australia' },
        { key: 'en-au', value: 'Australia' },
        { key: 'nz-en', value: 'New Zealand' },
        { key: 'en-nz', value: 'New Zealand' },
        { key: 'BE', value: 'Belgium' },
        { key: 'en-be', value: 'Belgium' },
        { key: 'be-en', value: 'Belgium' },
        { key: 'ja', value: 'Japan' },
        { key: 'jp-jp', value: 'Japan' },
        { key: 'en-us', value: 'United States' },
        { key: 'us-en', value: 'United States' },
        { key: 'en-in', value: 'India' },
        { key: 'SE', value: 'Sweden' },
        { key: 'no-no', value: 'Norway' },
        { key: 'se-en', value: 'Sweden' },
        { key: 'NO', value: 'Norway' },
        { key: 'RO', value: 'Romania' },
        { key: 'at-de', value: 'Austria' },
        { key: 'de-at', value: 'Austria' },
        { key: 'AT', value: 'Austria' },
        { key: 'AUT', value: 'Austria' },
        { key: 'PT', value: 'Portugal' },
        { key: 'DK', value: 'Denmark' },
        { key: 'FI', value: 'Finland' },
        { key: 'CH', value: 'Switzerland' },
        { key: 'CHE', value: 'Switzerland' },
        { key: 'en-ch', value: 'Switzerland' },
        { key: 'ch-en', value: 'Switzerland' },
        { key: 'HU', value: 'Hungary' },
        { key: 'pt-br', value: 'Brazil' },
        { key: 'CZ', value: 'Czech Republic' },
        { key: 'cz-en', value: 'Czech Republic' },
        { key: 'en-cz', value: 'Czech Republic' },
        { key: 'en-CZ', value: 'Czech Republic' },
        { key: 'CZE', value: 'Czech Republic' },
        { key: 'en-sg', value: 'Singapore' },
        { key: 'en-eg', value: 'Egypt' },
        { key: 'eg-en', value: 'Egypt' },
        { key: 'EG', value: 'Egypt' },
        { key: 'es-ar', value: 'Argentina' },
        { key: 'ma-fr', value: 'Morocco' },
        { key: 'en-ca', value: 'Canada' },
        { key: 'en-hk', value: 'Hong Kong SAR' },
        { key: 'en-my', value: 'Malaysia' },
        { key: 'en-ph', value: 'Philippines' },
        { key: 'tn-fr', value: 'Tunisia' },
        { key: 'ma-en', value: 'Morocco' },
        { key: 'en-ma', value: 'Morocco' },
        { key: 'lu-en', value: 'Luxembourg' },
        { key: 'en-lu', value: 'Luxembourg' },
        { key: 'LU', value: 'Luxembourg' },
        { key: 'ro-en', value: 'Romania' },
        { key: 'en-ro', value: 'Romania' },
        { key: 'ie-en', value: 'Ireland' },
        { key: 'en-ie', value: 'Ireland' },
        { key: 'hu-en', value: 'Hungary' },
        { key: 'tn-en', value: 'Tunisia' },
        { key: 'en-tn', value: 'Tunisia' },
        { key: 'sk-en', value: 'Slovakia' },
        { key: 'en-sk', value: 'Slovakia' },
        { key: 'ua-en', value: 'Ukraine' },
        { key: 'en-ua', value: 'Ukraine' },
        { key: 'en-fi', value: 'Finland' },
        { key: 'en-se', value: 'Sweden' },
        { key: 'en-dk', value: 'Denmark' },
        { key: 'dk-en', value: 'Denmark' },
        { key: 'en-no', value: 'Norway' },
        { key: 'no-en', value: 'Norway' },
        { key: 'en-hu', value: 'Hungary' },
        { key: 'ph-en', value: 'Philippines' },
        { key: 'my-en', value: 'Malaysia' },
        { key: 'hk-en', value: 'Hong Kong SAR' },
        { key: 'ca-en', value: 'Canada' },
        { key: 'sg-en', value: 'Singapore' },
        { key: 'en-gu', value: 'Guatemala' },
        { key: 'gb-en', value: 'United Kingdom' },
        { key: 'en-ae', value: 'UAE' },
        { key: 'ae-en', value: 'UAE' },
        { key: 'en-gr', value: 'Greece' },
        { key: 'gr-en', value: 'Greece' },
        { key: 'en-rs', value: 'Serbia' },
        { key: 'rs-en', value: 'Serbia' }
      ];

      const FinalCountryName = pre_defined_country_list.filter(temp => (temp.key === CountryCode));
      if (FinalCountryName[0]) {
        return FinalCountryName[0].value;
      }

      return CountryCode;
    }

    function checkForTranslation (label, filterType) {
      const cg_jobs_translated_filters = `${window.cg_jobs_translated_filters_v1}` ? JSON.parse(`${window.cg_jobs_translated_filters_v1}`) : {};

      // Split the label into an array if it contains commas
      const labels = label?.split(',');

      // Translate each value and join them back into a comma-separated string
      const translatedLabels = labels?.map((singleLabel) => {
        const trimmedLabel = singleLabel?.trim(); // Remove extra spaces
        if (
          cg_jobs_translated_filters &&
          filterType in cg_jobs_translated_filters &&
          encodeURIComponent(trimmedLabel) in cg_jobs_translated_filters[filterType] &&
          cg_jobs_translated_filters[filterType][encodeURIComponent(trimmedLabel)] !== ''
        ) {
          return cg_jobs_translated_filters[filterType][encodeURIComponent(trimmedLabel)];
        }
        return trimmedLabel; // Return original label if no translation is found
      });

      return translatedLabels?.join(', '); // Join the translated labels back into a string
    }

    return (
      <a className="table-tr filter-box tag-active joblink" href={base_slug + '/jobs/' + this.props.data.ref + '+' + this.props.data.source.toLowerCase() + '/'}>
        <div className="table-td table-title" style={{ display: (this.props.filtercolumnselections).includes('job_name') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Job name', 'macs-react-jobs') }</span>
          <div>{this.props.data.title}</div>
        </div>
        <div className="table-td table-title td-style" style={{ display: (this.props.filtercolumnselections).includes('country') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Country', 'macs-react-jobs') }</span>
          <div>{getCountryNameByCode(this.props.data.country_code)}</div>
        </div>
        <div className="table-td table-title td-style" style={{ display: (this.props.filtercolumnselections).includes('location') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Location', 'macs-react-jobs') }</span>
          <div>{checkForTranslation(this.props.data.location, 'location')}  </div>
        </div>
        <div className="table-td table-title td-style" style={{ display: (this.props.filtercolumnselections).includes('experience_level') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Experience level', 'macs-react-jobs') }</span>
          <div>{checkForTranslation(this.props.data.experience_level, 'experience_level')}</div>
        </div>
        <div className="table-td table-title td-style" style={{ display: (this.props.filtercolumnselections).includes('department') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Department', 'macs-react-jobs') }</span>
          <div>{this.props.data.department}</div>
        </div>
        <div className="table-td table-title td-style" style={{ display: (this.props.filtercolumnselections).includes('contract_type') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Contract Type', 'macs-react-jobs') }</span>
          <div>{checkForTranslation(this.props.data.contract_type, 'contract_type')}</div>
        </div>
        <div className="table-td table-title td-style" style={{ display: (this.props.filtercolumnselections).includes('business_units') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Business Unit', 'macs-react-jobs') }</span>
          <div>{this.props.data.sbu}</div>
        </div>
        <div className="table-td table-title td-style" style={{ display: (this.props.filtercolumnselections).includes('professional_communities') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Professional communities', 'macs-react-jobs') }</span>
          <div>{checkForTranslation(this.props.data.professional_communities, 'professional_communities')}</div>
        </div>
        <div className="table-td table-title td-style" style={{ display: (this.props.filtercolumnselections).includes('brand') == true ? '' : 'none' }}>
          <span className="table-td-header">{ __('Brand', 'macs-react-jobs') }</span>
          <div>{checkForTranslation(this.props.data.brand, 'brand')}</div>
        </div>
        { /*
        <div className="table-td table-title td-style">
          <span className="table-td-header">{ __( 'Posted on', 'macs-react-jobs' ) }</span>
          <div>{formatDate(theDate)}</div>
        </div>
      */ }
      </a>
    );
  }
}

export default JobTile;
